import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import "../../../_assets/css/custom.css";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/lib/styles.css";
import { postMethod } from "../../../_services/_postMethod";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import CustomerHeader from "./components/header";
import CustomerFooter from "./components/footer";
import CustomerBanner from "./components/banner";
import CustomerCategoryBanner from "./components/category_banner";
import { API_BASE_URL } from "../../../_services/constant";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Tab,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
  Tabs,
  TextField,
  Typography,
  Box,
  makeStyles,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Button,
  CardActions,
  DialogActions,
  Snackbar,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Input, Label, FormGroup } from "reactstrap";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const normalizeColor = (c) => {
  if (!c) return 'transparent';
  const str = String(c).trim().toLowerCase();
  const map = {
    rose: '#b76e79',
    'rose gold': '#b76e79',
    rosegold: '#b76e79',
    pink: '#ffc0cb',
    yellow: '#ffd700',
    'yellow gold': '#ffd700',
    gold: '#ffd700',
    white: '#e5e4e2',
    'white gold': '#e5e4e2',
    platinum: '#e5e4e2',
    silver: '#c0c0c0',
    bronze: '#cd7f32',
    black: '#333333',
    red: '#e53935',
    blue: '#1e88e5',
    green: '#43a047',
  };
  return map[str] || str;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: 224,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    width: 175,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#000",
    backgroundColor: "#fff",
  },
  // New Styles
  productGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: '16px',
    padding: '16px 0',
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '8px',
      padding: '8px 0',
    },
  },
  productCard: {
    borderRadius: '16px',
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.12)',
      '& $cardImage': {
        transform: 'scale(1.05)',
      },
      '& $wishlistIcon': {
        opacity: 1,
        transform: 'translateY(0)',
      }
    }
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    paddingTop: '100%', /* 1:1 Aspect Ratio */
    overflow: 'hidden',
    backgroundColor: '#f8f9fa',
  },
  cardImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transition: 'transform 0.5s ease',
  },
  cardContent: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between',
    '@media (max-width: 600px)': {
      padding: '8px',
    },
  },
  productTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '2px',
    fontFamily: '"Inter", "Outfit", sans-serif',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textDecoration: 'none',
    '@media (max-width: 600px)': {
      fontSize: '0.8rem',
    },
  },
  productSize: {
    fontSize: '0.85rem',
    color: '#aaa',
    marginBottom: '8px',
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    flexWrap: 'wrap',
    marginTop: 'auto',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
    },
  },
  currentPrice: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#000',
  },
  originalPrice: {
    fontSize: '0.9rem',
    color: '#888',
    textDecoration: 'line-through',
  },
  wishlistIcon: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    cursor: 'pointer',
    color: '#ff3366',
    background: 'white',
    borderRadius: '50%',
    color: '#999',
    '&.active': {
      opacity: 1,
      transform: 'translateY(0)',
      color: 'red',
    },
    '&:hover': {
      color: 'red',
      transform: 'scale(1.1) translateY(0)',
    }
  },
  badge: {
    position: 'absolute',
    top: '12px',
    left: '12px',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    zIndex: 10,
  },
  badgeNew: {
    backgroundColor: '#000',
    color: '#fff',
  },
  badgeTrial: {
    top: 'auto',
    bottom: '12px',
    backgroundColor: '#e6f7ff',
    color: '#0050b3',
    border: '1px solid #91d5ff',
  },
  sidebarContainer: {
    background: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(20px)',
    borderRadius: '20px',
    padding: '24px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    position: 'sticky',
    top: '20px',
  },
  sidebarTitle: {
    fontSize: '1.2rem',
    fontWeight: 700,
    marginBottom: '20px',
    color: '#111',
  },
  priceSection: {
    padding: '16px 0',
    borderBottom: '1px solid #f0f0f0',
    marginBottom: '8px',
  },
  priceTitle: {
    fontWeight: 600,
    fontSize: '0.95rem',
    marginBottom: '20px',
    color: '#333',
  },
  accordionRoot: {
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
    borderBottom: '1px solid #f0f0f0 !important',
    borderRadius: '0 !important',
    margin: '0 !important',
    '&:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root': {
      padding: '12px 0 !important',
      minHeight: 'auto !important',
    },
    '& .MuiAccordionSummary-content': {
      margin: '0 !important',
      fontWeight: 600,
      fontSize: '0.95rem',
      color: '#333',
    },
    '& .MuiAccordionDetails-root': {
      padding: '0 0 16px 0 !important',
    },
  },
  sortSelect: {
    padding: '10px 16px',
    borderRadius: '12px',
    border: '1px solid #eee',
    background: '#fff',
    outline: 'none',
    boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
    fontWeight: 500,
    cursor: 'pointer',
    width: '100%',
    maxWidth: '250px',
    appearance: 'none',
    backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    backgroundSize: '16px',
  }
}));

const CustomerProducts = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { register, handleSubmit, errors } = useForm();
  const [isvalid, setValid] = useState(false);
  const [load, setLoad] = useState(false);
  const inputRef = React.createRef(null);
  const [sortOpen, setsortOpen] = useState(false);

  const [masterProducts, setMasterProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [category, setCategory] = useState("");
  const [material, setMaterial] = useState("");
  const [orderPrice, setOrderPrice] = useState("desc");
  const [short_filters, setShortFilters] = useState({
    new: false,
    order: "desc",
    trial: false,
  });
  const [genders, setGenders] = useState("");
  const [gender, setGender] = useState("");
  const [metals, setMetals] = useState("");
  const [metal, setMetal] = useState("");
  const [priceRange, setPriceRange] = useState({ min: 0, max: 0 });
  const [priceRangeSet, setPriceRangeSet] = useState({ min: 0, max: 0 });
  const [sizeList, setSizeList] = useState([]);
  const [size, setSize] = useState("");
  const [weightList, setWeightList] = useState([]);
  const [weight, setWeight] = useState("");
  const [colors, setColors] = useState([]);
  const [colorFilter, setColorFilter] = useState("");
  const [voucherList, setVoucherList] = useState([]);
  const [Tabvalue, setValue] = React.useState(0);
  const [productCount, setProductCount] = React.useState(0);
  const [show, setShow] = useState(false);
  const [sortObj, setSortObj] = useState({
    new: false,
    hightolow: false,
    lowtohigh: false,
    new: false,
    tryathome: false,
    shortingApplied: false
  });

  const applyShorting = () => {
    let shortValue = "";
    if (sortObj.new) {
      shortValue = "new";
    }
    if (sortObj.hightolow) {
      shortValue = "desc";
    }
    if (sortObj.lowtohigh) {
      shortValue = "asc";
    }
    if (sortObj.tryathome) {
      shortValue = "trial";
    }
    setFilter(shortValue);
    setSortObj({ ...sortObj, shortingApplied: true })
    setsortOpen(false);
  }


  const handleModal = () => {
    setOpen(!open);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSortModal = () => {
    setsortOpen(!sortOpen);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getEffectivePrice = (p) => {
    const dp = Number(p.discounted_price);
    return (dp && dp > 0) ? dp : Number(p.price || p.amount || 0);
  };

  const options = {
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
    dots: false,
    autoplay: true,
    // center:true,
    stagePadding: 10,
    margin: 10,
    loop: true,
    nav: true,
  };

  const RedirectToProduct = (product_id) => {
    localStorage.setItem("product_id", product_id);
    window.location.pathname = "trial-view/product-view";
  };

  useEffect(() => {
    setLoad(true);
    localStorage.setItem("subcategory_id", 0);

    postMethod("api/session/trial_products", {
      category_id: localStorage.getItem("category_id"),
      min_price: 0,
      max_price: 9999999999999,
      metal: "",
      material: "",
      subcategory_id: localStorage.getItem("subcategory_id"),
      price_order: short_filters.order,
      trial: short_filters.trial,
      new: short_filters.new,
      shop_for: "",
      skip: "0",
    }).then((data) => {
      if (data.data != "") {
        setMasterProducts(data.data);
        setProducts(data.data);
        if (data.data.length > 0) {
          const sizes = [...new Set(data.data.map(p => p.size_length).filter(Boolean))];
          const weights = [...new Set(data.data.map(p => p.weight).filter(Boolean))];
          const mats = [...new Set(data.data.map(p => p.material || p.Material).filter(Boolean))];
          const mets = [...new Set(data.data.map(p => p.metal || p.Metal).filter(Boolean))];
          const colorsList = [...new Set(data.data.map(p => p.color || p.Color).filter(Boolean))];
          const maxPrice = Math.max(...data.data.map(p => getEffectivePrice(p)), 0);
          setSizeList(sizes);
          setWeightList(weights);
          setColors(colorsList);
          setMaterials(mats.map(m => ({ material: m, Material: m })));
          setMetals(mets.map(m => ({ metal: m, Metal: m })));
          setPriceRangeSet({ min: 0, max: maxPrice });
          setPriceRange({ min: 0, max: maxPrice });
        }
      }
      setLoad(false);
    });

    postMethod("api/session/trial_product_filter", {
      category_id: localStorage.getItem("category_id"),
    }).then((dataD) => {
      var data = dataD.data;
      setGenders(data[3]);
      setCategorys(data[4]);
    });
  }, []);

  // All filtering/sorting is done client-side using masterProducts — no API re-fetch needed.

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  const changeRange = (e) => {
    setPriceRange({ ...priceRange, min: e.min, max: e.max });
  };

  const categorychange = (category_id, subcategory_id) => {
    localStorage.setItem("category_id", category_id);
    localStorage.setItem("subcategory_id", subcategory_id);
    setLoad(true);
    setMaterial("");
    setMetal("");
    setSize("");
    setWeight("");

    postMethod("api/session/trial_products", {
      category_id: category_id,
      subcategory_id: subcategory_id,
      price_order: short_filters.order,
      trial: short_filters.trial,
      new: short_filters.new,
      min_price: 0,
      max_price: 0,
      metal: "",
      material: "",
      skip: "0",
    }).then((data) => {
      if (data.data != "") {
        setProducts(data.data);
        if (data.data.length > 0) {
          const sizes = [...new Set(data.data.map(p => p.size_length).filter(Boolean))];
          const weights = [...new Set(data.data.map(p => p.weight).filter(Boolean))];
          const mats = [...new Set(data.data.map(p => p.material || p.Material).filter(Boolean))];
          const mets = [...new Set(data.data.map(p => p.metal || p.Metal).filter(Boolean))];
          const colorsList = [...new Set(data.data.map(p => p.color || p.Color).filter(Boolean))];
          const maxPrice = Math.max(...data.data.map(p => getEffectivePrice(p)), 0);
          setSizeList(sizes);
          setWeightList(weights);
          setColors(colorsList);
          setMaterials(mats.map(m => ({ material: m, Material: m })));
          setMetals(mets.map(m => ({ metal: m, Metal: m })));
          setPriceRangeSet({ min: 0, max: maxPrice });
          setPriceRange({ min: 0, max: maxPrice });
        }
      }
    });

    postMethod("api/session/trial_product_filter", {
      category_id: category_id,
      subcategory_id: subcategory_id,
    }).then((dataD) => {
      var data = dataD.data;
      // metals and materials are now populated dynamically from trial_products above
      setGenders(data[3]);
      setCategorys(data[4]);

      setTimeout(() => {
        setLoad(false);
      }, 2000);
    });
  };

  const [openWish, setOpenWish] = React.useState(false);

  const handleClickWish = () => {
    setOpenWish(true);
  };

  const handleCloseWish = () => {
    setOpenWish(false);
  };

  const AddProductList = (type, product_id, price, wishFlag) => {
    postMethod("api/session/add_to_cart", {
      product_id: product_id,
      price: price,
      added_from: "trial",
      type: type,
    }).then((data) => {
      if (wishFlag != "true") {
        handleClickWish();
      }
      postMethod("api/session/wishlist", {}).then((dataD) => {
        setProductCount(dataD.data.length);
        // refresh wish state on current product list
        postMethod("api/session/trial_products", {
          category_id: localStorage.getItem("category_id"),
          subcategory_id: localStorage.getItem("subcategory_id"),
          price_order: short_filters.order,
          trial: short_filters.trial,
          new: short_filters.new,
          min_price: 0,
          max_price: 99999999,
          metal: "",
          material: "",
          shop_for: "",
          skip: "0",
        }).then((d) => {
          if (d.data && d.data != "") {
            setMasterProducts(d.data);
          }
        });
      });
    });
  };

  const setFilter = (value) => {
    if (value == "desc") {
      setShortFilters({
        ...short_filters,
        new: false,
        order: "desc",
        trial: false,
      });
    }
    if (value == "asc") {
      setShortFilters({
        ...short_filters,
        new: false,
        order: "asc",
        trial: false,
      });
    }
    if (value == "new") {
      setShortFilters({
        ...short_filters,
        new: true,
        order: "desc",
        trial: false,
      });
    }
    if (value == "trial") {
      setShortFilters({
        ...short_filters,
        new: false,
        order: "desc",
        trial: true,
      });
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CustomerHeader count={productCount} />
      <CustomerCategoryBanner />
      <Snackbar
        open={openWish}
        autoHideDuration={5000}
        onClose={handleCloseWish}
        message="Product added to wish list. Customer executive will contact you soon."
      />
      <div className="container-fluid my-0.5">
        <div className="row prosection  py-md-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-3 botpad8 d-none d-lg-block d-md-block">
                <div
                  id="accordion"
                  className={classes.sidebarContainer}
                >
                  <div className="panel-heading d-flex justify-content-between align-items-center mb-3">
                    <h3 className={classes.sidebarTitle} style={{ marginBottom: 0 }}>Filters By </h3>
                    {(metal || material || gender || colorFilter || weight || size || localStorage.getItem("category_id")) ? (
                      <span
                        style={{ cursor: "pointer", color: "#e53935", fontSize: "0.85rem", fontWeight: 600 }}
                        onClick={() => {
                          setMetal("");
                          setMaterial("");
                          setGender("");
                          setColorFilter("");
                          setWeight("");
                          setSize("");
                          localStorage.removeItem("category_id");
                          localStorage.removeItem("subcategory_id");
                        }}
                      >
                        Clear All
                      </span>
                    ) : null}
                  </div>
                  <div className="panel-body">
                    <div className="panel-heading">
                      <Accordion className={classes.accordionRoot} elevation={0}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>Categories</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', paddingTop: 0 }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                              <input
                                type="radio"
                                name="categoryname"
                                checked={!localStorage.getItem("category_id")}
                                onChange={() => {
                                  localStorage.removeItem("category_id");
                                  localStorage.removeItem("subcategory_id");
                                  categorychange("", "");
                                }}
                                style={{ margin: 0, cursor: 'pointer' }}
                              />
                              <span>ALL</span>
                            </label>
                            {categorys &&
                              categorys.map((prop, i) => {
                                const isSelected = localStorage.getItem("category_id") == prop.category_id;
                                return (
                                  <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                    <input
                                      type="radio"
                                      name="categoryname"
                                      checked={isSelected}
                                      onChange={() => {
                                        localStorage.setItem("jwl_category_banner_path", prop.banner_path);
                                        categorychange(prop.category_id, "");
                                      }}
                                      style={{ margin: 0, cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: isSelected ? '700' : '400' }}>{prop.category_name}</span>
                                  </label>
                                );
                              })}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>

                    <div className={classes.priceSection}>
                      <div className={classes.priceTitle}>Price</div>
                      <InputRange
                        maxValue={priceRangeSet.max}
                        minValue={0}
                        value={priceRange}
                        onChange={changeRange}
                      />
                    </div>

                    {metals && metals.length > 0 && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>Metal</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="metal"
                                  checked={metal === ""}
                                  onChange={() => setMetal("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {metals.map((prop, i) => {
                                const val = prop.Metal || prop.metal;
                                return (
                                  <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                    <input
                                      type="radio"
                                      name="metal"
                                      checked={metal === val}
                                      onChange={(e) => {
                                        if (e.target.checked) setMetal(val);
                                        else setMetal("");
                                      }}
                                      style={{ margin: 0, cursor: 'pointer' }}
                                    />
                                    <span>{val}</span>
                                  </label>
                                );
                              })}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                    {materials && materials.length > 0 && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>Material</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="material"
                                  checked={material === ""}
                                  onChange={() => setMaterial("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {materials.map((prop, i) => {
                                const val = prop.Material || prop.material;
                                return (
                                  <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                    <input
                                      type="radio"
                                      name="material"
                                      checked={material === val}
                                      onChange={(e) => {
                                        if (e.target.checked) setMaterial(val);
                                        else setMaterial("");
                                      }}
                                      style={{ margin: 0, cursor: 'pointer' }}
                                    />
                                    <span>{val}</span>
                                  </label>
                                );
                              })}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                    {genders && genders.length > 0 && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>Shop For</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="gender"
                                  checked={gender === ""}
                                  onChange={() => setGender("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {genders.map((prop, i) => {
                                const val = prop.gender || prop.Gender;
                                return (
                                  <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                    <input
                                      type="radio"
                                      name="gender"
                                      checked={gender === val}
                                      onChange={(e) => {
                                        if (e.target.checked) setGender(val);
                                        else setGender("");
                                      }}
                                      style={{ margin: 0, cursor: 'pointer' }}
                                    />
                                    <span>{val}</span>
                                  </label>
                                );
                              })}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                    {sizeList && sizeList.length > 0 && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Size</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="size"
                                  checked={size === ""}
                                  onChange={() => setSize("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {sizeList.map((prop, i) => (
                                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                  <input
                                    type="radio"
                                    name="size"
                                    checked={size === prop}
                                    onChange={(e) => {
                                      if (e.target.checked) setSize(prop);
                                    }}
                                    style={{ margin: 0, cursor: 'pointer' }}
                                  />
                                  <span>{prop}</span>
                                </label>
                              ))}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                    {weightList && weightList.length > 0 && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Weight</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="weight"
                                  checked={weight === ""}
                                  onChange={() => setWeight("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {weightList.map((prop, i) => (
                                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                  <input
                                    type="radio"
                                    name="weight"
                                    checked={weight === prop}
                                    onChange={(e) => {
                                      if (e.target.checked) setWeight(prop);
                                    }}
                                    style={{ margin: 0, cursor: 'pointer' }}
                                  />
                                  <span>{prop}</span>
                                </label>
                              ))}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                    {colors && colors.length > 0 && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Color</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 12px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="color"
                                  checked={colorFilter === ""}
                                  onChange={() => setColorFilter("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {colors.map((c, i) => (
                                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                  <input
                                    type="radio"
                                    name="color"
                                    checked={colorFilter === c}
                                    onChange={(e) => {
                                      if (e.target.checked) setColorFilter(c);
                                    }}
                                    style={{ margin: 0, cursor: 'pointer' }}
                                  />
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <span style={{
                                      display: 'inline-block',
                                      width: 12,
                                      height: 12,
                                      borderRadius: '50%',
                                      backgroundColor: normalizeColor(c),
                                      border: '1px solid rgba(0,0,0,0.15)',
                                      flexShrink: 0,
                                    }} />
                                    {c}
                                  </span>
                                </label>
                              ))}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                id="sidebar"
                className="sidebar col-12 d-none d-lg-none d-md-none d-block"
              >
                {open ? null : (
                  <div className="container-fluid p-0">
                    <div className="row no-gutters">
                      <div className="col-6 lrpadd">
                        <button
                          type="button"
                          className="fltrbtn"
                          onClick={handleSortModal}
                        >
                          <i
                            className="fa fa-sort text-white"
                            aria-hidden="true"
                          ></i>{" "}
                          Sort By
                        </button>
                      </div>
                      <div className="col-6 lrpadd leftbdr">
                        <button
                          type="button"
                          className="fltrbtn"
                          onClick={handleModal}
                        >
                          <i
                            className="fa fa-filter text-white"
                            aria-hidden="true"
                          ></i>{" "}
                          Filter By
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="modal fade"
                  id="filterModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog fltrmodal-dialog"
                    role="document"
                  >
                    <div className="modal-content fltrmodal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="fltrclose"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">
                            <i
                              className="fa fa-chevron-left"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </button>
                        <span>
                          <button type="button" className="fltrclr">
                            Clear All
                          </button>
                        </span>
                      </div>
                      <div className="modal-body fltrmodal-body">
                        <div className="tab">
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'price')"
                            id="defaultOpen"
                          >
                            Price
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'weight')"
                          >
                            Weight
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'material')"
                          >
                            Material
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'metal')"
                          >
                            Metal
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'size')"
                          >
                            Size/Lenth
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'shop')"
                          >
                            Shop For
                          </button>
                        </div>
                        <div id="price" className="tabcontent"></div>
                        <div id="weight" className="tabcontent">
                          <h3>Weight</h3>
                          <p>Paris is the capital of France.</p>
                        </div>
                        <div id="material" className="tabcontent">
                          <h3>Material</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div id="metal" className="tabcontent">
                          <h3>Metal</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div id="size" className="tabcontent">
                          <h3>Size/Lenth</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div id="shop" className="tabcontent">
                          <h3>Shop For</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div className="aplybutnbx">
                          <button className="btn allbtn" type="button">
                            APPLY FILTERS
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="modal fade"
                  id="sortModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog fltrmodal-dialog"
                    role="document"
                  >
                    <div className="modal-content fltrmodal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="fltrclose"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">
                            <i
                              className="fa fa-chevron-left"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </button>

                        <span>
                          <button type="button" className="fltrclr">
                            Clear All
                          </button>
                        </span>
                      </div>
                      <div className="modal-body fltrmodal-body">
                        vmxcplvxz
                        <button className="aplybutn btn" type="button">
                          APPLY FILTERS
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-9 col-lg-9">
                <div className="row d-none d-lg-block d-md-block">
                  <div className="sortprobx d-flex justify-content-end w-100 mb-3">
                    <div className="form-group sortpro d-flex align-items-center mb-0" style={{ gap: '12px' }}>
                      <label className="mb-0 font-weight-bold" style={{ whiteSpace: 'nowrap' }}>Sort By</label>
                      <select
                        id="inputState"
                        className={classes.sortSelect}
                        onChange={(e) => {
                          setFilter(e.target.value);
                        }}
                      >
                        <option selected value="desc">
                          Choose option
                        </option>
                        <option value="new">New</option>
                        <option value="desc">Price: Low to High</option>
                        <option value="asc"> Price: High to Low</option>
                        <option value="trial">Try at Home</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="clr"></div>
                <div className={classes.productGrid}>
                  {(() => {
                    let list = [...masterProducts];
                    // sort / short_filters
                    if (short_filters.trial) {
                      list = list.filter(p => p.trial == true || p.trial === "true");
                    }
                    if (short_filters.new) {
                      list = list.filter(p => p.new == true || p.new === "true");
                    }
                    if (short_filters.order === "asc") {
                      list = [...list].sort((a, b) => getEffectivePrice(b) - getEffectivePrice(a));
                    } else if (short_filters.order === "desc") {
                      list = [...list].sort((a, b) => getEffectivePrice(a) - getEffectivePrice(b));
                    }
                    // metal / material / gender
                    if (metal) list = list.filter(p => (p.metal || p.Metal) === metal);
                    if (material) list = list.filter(p => (p.material || p.Material) === material);
                    if (gender) list = list.filter(p => (p.gender || p.Gender) === gender);
                    // price / size / weight / color
                    list = list.filter(prop => {
                      const effectivePrice = getEffectivePrice(prop);
                      const matchPrice = effectivePrice >= priceRange.min && effectivePrice <= (priceRange.max || 99999999);
                      const matchSize = size === "" || prop.size_length === size;
                      const matchWeight = weight === "" || prop.weight === weight;
                      const matchColor = colorFilter === "" || (prop.color && String(prop.color).toLowerCase() === String(colorFilter).toLowerCase());
                      return matchPrice && matchSize && matchWeight && matchColor;
                    });
                    return list.map((prop, i) => {
                      if (!prop || Object.keys(prop).length === 0) return null;
                      return (
                        <div className={classes.productCard} key={i}>
                          <div
                            className={`${classes.wishlistIcon} ${prop.wish == "true" || prop.wish === true ? "active" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              AddProductList("trial", prop.product_id, prop.price, prop.wish);
                            }}
                          >
                            <i
                              className={prop.wish == "true" || prop.wish === true ? "fas fa-heart" : "far fa-heart"}
                              style={{ color: (prop.wish == "true" || prop.wish === true) ? "red" : "" }}
                            ></i>
                          </div>

                          <div onClick={() => RedirectToProduct(prop.product_id)}>
                            <div className={classes.imageContainer}>
                              {prop.new == true ? (
                                <div className={`${classes.badge} ${classes.badgeNew}`}>New</div>
                              ) : null}
                              {prop.new != true && prop.trial == true ? (
                                <div className={`${classes.badge} ${classes.badgeTrial}`}>
                                  Try at Home
                                </div>
                              ) : null}
                              <img
                                className={classes.cardImage}
                                src={
                                  prop?.isImageUrl
                                    ? prop.image_path
                                    : `${API_BASE_URL}Images/${prop?.image_path || ""}`
                                }
                                alt={prop.product_name}
                              />
                            </div>
                            <div className={classes.cardContent}>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6 }}>
                                <div className={classes.productTitle}>{prop.product_name}</div>
                                {prop.color && (
                                  <span title={prop.color} style={{
                                    display: 'inline-block',
                                    width: 14,
                                    height: 14,
                                    borderRadius: '50%',
                                    backgroundColor: normalizeColor(prop.color),
                                    border: '1px solid rgba(0,0,0,0.15)',
                                    flexShrink: 0,
                                  }} />
                                )}
                              </div>
                              {prop.size_length ? (
                                <div className={classes.productSize}>Size: {prop.size_length}</div>
                              ) : null}
                              {(localStorage.getItem("jwl_hide_price") == 'false' || localStorage.getItem("jwl_hide_price") == false) ? (
                                <div className={classes.priceContainer}>
                                  {Number(prop.discounted_price) > 0 ? (
                                    <>
                                      <span className={classes.currentPrice}>₹ {prop.discounted_price}</span>
                                      <span className={classes.originalPrice}>₹ {prop.price}</span>
                                    </>
                                  ) : (
                                    <span className={classes.currentPrice}>₹ {prop.price}</span>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>
              <div className="clr"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="clr"></div>
      <CustomerBanner />
      <br />{/* Sort Modal */}
      <Dialog fullScreen open={sortOpen} TransitionComponent={Transition}>
        <DialogTitle id="form-dialog-title" className="p-0">
          <IconButton
            onClick={handleSortModal}
            aria-label="upload picture"
            component="span"
          >
            <i className="fas fa-arrow-left"></i>
            <span className="pl-3">Sort</span>
          </IconButton>
        </DialogTitle>
        <DialogContent className="p-3">
          <div
            className={
              "filterOption  mb-4 " + (sortObj.lowtohigh ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, hightolow: false, lowtohigh: true })}
          >
            <i className={"fas fa-long-arrow-alt-up"}></i>
            <span>Lowest to Highest</span>
          </div>
          <div
            className={
              "filterOption  mb-4 " + (sortObj.hightolow ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, hightolow: true, lowtohigh: false })}
          >
            <i className={"fas fa-long-arrow-alt-down"}></i>
            <span>Highest to Lowest</span>
          </div>
          <div
            className={
              "filterOption  mb-4 " + (sortObj.new ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, new: true, hightolow: false, lowtohigh: false })}
          >
            <i className={"fa fa-star-o"}></i>
            <span>New</span>
          </div>
          <FormGroup check>


            <input type="checkbox" /> New
          </FormGroup>
          <FormGroup check style={{ marginTop: 10 }}>

            <input type="checkbox" /> Try at Home

          </FormGroup>
        </DialogContent>
        <DialogActions>
          <button
            className="fltrbtn btm w-100 py-3"
            onClick={() => setsortOpen(false)}
          >
            Apply Sort
          </button>
        </DialogActions>
      </Dialog>

      {/* Filter Modal */}
      <Dialog fullScreen open={open} TransitionComponent={Transition}>
        <DialogTitle id="form-dialog-title" className="p-0">
          <IconButton
            onClick={handleModal}
            aria-label="upload picture"
            component="span"
          >
            <i className="fas fa-arrow-left"></i>
            <span className="pl-3">Filters</span>
          </IconButton>
        </DialogTitle>
        <DialogContent className="d-flex p-0">
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={Tabvalue}
            className={classes.tabs}
            onChange={handleChange}
            aria-label="Vertical tabs example"
          >
            <Tab label="Price" {...a11yProps(0)} />
            <Tab label="Metal" {...a11yProps(1)} style={{ display: metals && metals.length > 0 ? undefined : 'none' }} />
            <Tab label="Material" {...a11yProps(2)} style={{ display: materials && materials.length > 0 ? undefined : 'none' }} />
            <Tab label="Shop For" {...a11yProps(3)} style={{ display: genders && genders.length > 0 ? undefined : 'none' }} />
            <Tab label="Size" {...a11yProps(4)} style={{ display: sizeList && sizeList.length > 0 ? undefined : 'none' }} />
            <Tab label="Weight" {...a11yProps(5)} style={{ display: weightList && weightList.length > 0 ? undefined : 'none' }} />
            <Tab label="Color" {...a11yProps(6)} style={{ display: colors && colors.length > 0 ? undefined : 'none' }} />
          </Tabs>
          <div
            className={
              (Tabvalue != "0" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            <div className="mt-5">
              <InputRange
                maxValue={priceRangeSet.max}
                minValue={0}
                value={priceRange}
                onChange={changeRange}
              />
            </div>
          </div>
          <div
            className={
              (Tabvalue != "1" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            {metals &&
              metals.map((prop, i) => {
                return (
                  <div
                    className={
                      "filterOption mb-4 " +
                      (prop.Metal === metal ? "active" : "")
                    }
                    onClick={() => setMetal(prop.Metal)}
                  >
                    <i className="fas fa-check"></i>
                    <span>{prop.Metal}</span>
                  </div>
                );
              })}
            <div
              className={
                "filterOption  mb-4 " +
                (metal === '' ? "active" : "")
              }
              onClick={() => setMetal('')}
            >
              <i className="fas fa-check"></i>
              <span>All</span>
            </div>
          </div>
          <div
            className={
              (Tabvalue != "2" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            {materials &&
              materials.map((prop, i) => {
                return (
                  <div
                    className={
                      "filterOption  mb-4 " +
                      (prop.material === material ? "active" : "")
                    }
                    onClick={() => setMaterial(prop.material)}
                  >
                    <i className="fas fa-check"></i>
                    <span>{prop.material}</span>
                  </div>
                );
              })}
            <div
              className={
                "filterOption  mb-4 " +
                (material === '' ? "active" : "")
              }
              onClick={() => setMaterial('')}
            >
              <i className="fas fa-check"></i>
              <span>All</span>
            </div>
          </div>
          <div
            className={
              (Tabvalue != "3" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            {genders &&
              genders.map((prop, i) => {
                return (
                  <div
                    className={
                      "filterOption mb-4 " +
                      (prop.gender === gender ? "active" : "")
                    }
                    onClick={() => setGender(prop.gender)}
                  >
                    <i className="fas fa-check"></i>
                    <span>{prop.gender}</span>
                  </div>
                );
              })}
            <div
              className={
                "filterOption  mb-4 " +
                (gender === '' ? "active" : "")
              }
              onClick={() => setGender('')}
            >
              <i className="fas fa-check"></i>
              <span>All</span>
            </div>
          </div>
          {sizeList && sizeList.length > 0 && (
            <div className={(Tabvalue != "4" ? "d-none" : "") + " bg-light container pt-3"}>
              {sizeList.map((prop, i) => (
                <div
                  key={i}
                  className={"filterOption mb-4 " + (prop === size ? "active" : "")}
                  onClick={() => setSize(prop)}
                >
                  <i className="fas fa-check"></i>
                  <span>{prop}</span>
                </div>
              ))}
              <div className={"filterOption mb-4 " + (size === '' ? "active" : "")} onClick={() => setSize('')}>
                <i className="fas fa-check"></i>
                <span>All</span>
              </div>
            </div>
          )}
          {weightList && weightList.length > 0 && (
            <div className={(Tabvalue != "5" ? "d-none" : "") + " bg-light container pt-3"}>
              {weightList.map((prop, i) => (
                <div
                  key={i}
                  className={"filterOption mb-4 " + (prop === weight ? "active" : "")}
                  onClick={() => setWeight(prop)}
                >
                  <i className="fas fa-check"></i>
                  <span>{prop}</span>
                </div>
              ))}
              <div className={"filterOption mb-4 " + (weight === '' ? "active" : "")} onClick={() => setWeight('')}>
                <i className="fas fa-check"></i>
                <span>All</span>
              </div>
            </div>
          )}
          {colors && colors.length > 0 && (
            <div className={(Tabvalue != "6" ? "d-none" : "") + " bg-light container pt-3"}>
              {colors.map((c, i) => (
                <div
                  key={i}
                  className={"filterOption mb-4 " + (c === colorFilter ? "active" : "")}
                  onClick={() => setColorFilter(c === colorFilter ? "" : c)}
                >
                  <i className="fas fa-check"></i>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{
                      display: 'inline-block',
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      backgroundColor: normalizeColor(c),
                      border: '1px solid rgba(0,0,0,0.15)'
                    }} />
                    {c}
                  </span>
                </div>
              ))}
              <div className={"filterOption mb-4 " + (colorFilter === '' ? "active" : "")} onClick={() => setColorFilter('')}>
                <i className="fas fa-check"></i>
                <span>All</span>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <button
            className="fltrbtn btm w-100 py-3"
            onClick={() => setOpen(false)}
          >
            Apply Filter
          </button>
        </DialogActions>
      </Dialog>


      <CustomerFooter />
    </>
  );
};

export default CustomerProducts;
